/**
 *
 * @param note
 */
export function getType(note) {
    return note.type;
}
